import cn from 'classnames';
import { useRef } from 'react';

import { SidebarMenu, TableOfContent } from '@/components/static';
import { TOC_UPDATE_DELAY_MS } from '@/constant/common';
import { useAnchor, useScrollToAnchorOnMount } from '@/hooks/navigation';
import { useAutoUpdateActiveTOC } from '@/hooks/navigation';

import { NavPanel } from './NavPanel';
import s from './styles.module.scss';
import { PageNavigationProps } from './types';

export function PageNavigation({
  children,
  TOCList,
  TOCClassName,
  getActiveElementParentIdsPred,
}: PageNavigationProps) {
  const scrollToAnchorTimeRef = useRef<number>(Date.now());

  const updateScrollToAnchorTimeRef = (time: number) => {
    scrollToAnchorTimeRef.current = time;
  };

  const { anchor, updateAnchor } = useAnchor(updateScrollToAnchorTimeRef);

  const externalUpdateActiveTocElementPredicate = (updateTic: number) => {
    if (!scrollToAnchorTimeRef.current) return false;
    const timeDiff = updateTic - scrollToAnchorTimeRef.current;
    return timeDiff > TOC_UPDATE_DELAY_MS;
  };

  useScrollToAnchorOnMount(updateScrollToAnchorTimeRef);

  useAutoUpdateActiveTOC(externalUpdateActiveTocElementPredicate, updateAnchor);

  return (
    <div className={s.page_wrapper}>
      <NavPanel anchor={anchor || ''} rootClassName={s.hide_on_desktop} TOCList={TOCList} />

      <SidebarMenu rootClassName={s.hide_on_mobile} />
      {children}
      <TableOfContent
        getActiveElementParentIdsPred={getActiveElementParentIdsPred}
        className={cn(s.hide_on_mobile, TOCClassName)}
        customList={TOCList}
      />
    </div>
  );
}
